<template>
  <div class="container">
    <img class="bg" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-rank-bg.png')">
    <div class="rank">
      <div class="rank-list-box">
             <div class="block"></div>
        <div class="rank-item" v-for="(item,index) of activityScanList" :key="index">
          <div class="rank-num">

            <img v-if="index===0" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-rank1.png')" />
            <img v-if="index===1" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-rank2.png')" />
            <img v-if="index===2" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-rank3.png')" />

            <div class="rank-num-normal" v-if="index!=0&&index!=1&&index!=2">{{index+1}}</div>
          </div>
          <div class="rank-name">
            <span class="info-4-clientName">{{item.clientName}}</span>
          </div>
          <div>
            {{item.bonusCount}}次
          </div>
        </div>
      </div>
      <div class="fixed-box">
        <div class="rank-item-fixed">
          <div class="rank-num">
            <img v-if="clientRanking===1" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-rank1.png')" />
            <img v-if="clientRanking===2" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-rank2.png')" />
            <img v-if="clientRanking===3" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-rank3.png')" />
            <div class="rank-num-normal" v-if="clientRanking!=0&&clientRanking!=1&&clientRanking!=2">{{clientRanking}}</div>
          </div>
          <div class="rank-name">
            <span class="info-4-clientName">{{clientName}}</span>
          </div>
          <div>
            {{scanCount}}次
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import activityApi from '@/api/activity'
import { userUtils } from '@/utils/auth'
export default {
  data () {
    return {
      clientRanking: '',
      scanCount: '',
      activityScanList: [],
      clientName: ''
    }
  },
  created () {
    this.getRankInfo()
    let userInfo = userUtils.getClientInfo()
    console.log(userInfo)
    this.clientName = userInfo.clientName
  },
  methods: {
    getRankInfo () {
      activityApi.get2022ScanRankingInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.activityScanList = res.data.resultData.activityScanList
          this.clientRanking = res.data.resultData.clientRanking
          this.scanCount = res.data.resultData.scanCount
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.bg{
  width: 90%;
  margin-top: 20px;
  margin-left: 5%;
  z-index: 1;
}
.container{
  background-image: url('https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/2022-scan/2022-scan-rank-bg2.jpg');
  height: 100vh;
}
.rank-list-box{
  position: relative;
  z-index: 10;
  width: 94%;
  margin-left: 3%;
  margin-top: -10px;
  background-color: white;
  height: 450px;
  border-radius: 10px;
  // border-top-left-radius:10px;
  // border-top-right-radius:10px;
  flex-wrap: wrap;
  overflow-y: auto;
  overflow-x: hidden;
}
.rank-item{
  min-height: 40px;
  align-items: center;
  width: 90%;
  margin-left: 5%;
  display: flex;
  justify-content: space-between;
  img{
    width: 35px;
  }
  .rank-name{
    width: 150px;
  }
  .img-sp{
    width: 68px;
  }
}
.rank-num-normal{
  width: 25px;
  margin-left: 10px;
  font-size: 18px;
}
.fixed-box{
  border-top: 1px solid rgb(12, 99, 73);
  z-index: 100;
  position: absolute;
  //bottom: 30px;
  width: 94%;
  margin-top: 5px;
  margin-left: 3%;
  // border-bottom-right-radius:10px;
  // border-bottom-left-radius:10px;
  border-radius: 10px;
  height: 50px;
  background-color: white;
    img{
    width: 70px;
  }
  .rank-name{
    width: 150px;
  }
  .img-sp{
    width: 68px;
  }
}
.block{
  width: 0;
  height: 8px;
}
.rank-item-fixed{
  min-height: 40px;
  align-items: center;
  width: 90%;
  margin-left: 5%;
  display: flex;
  justify-content: space-between;
}
.rank{
 // position: relative;
}
</style>
